import React, { useState, useEffect } from 'react';
import { InputGroup, InfoBox } from '../Common';

function runSimulation(c, wr, aw, al, ls, l) {
    const vpp = l * ls;
    const wr_dec = wr / 100;
    let eq = c;
    let peak = eq;
    let max_dd = 0;

    for (let i = 0; i < 1000; i++) {
        if (Math.random() < wr_dec) eq += aw * vpp;
        else eq -= al * vpp;

        if (eq > peak) peak = eq;

        const dd = peak > 0 ? (peak - eq) / peak : 0;
        if (dd > max_dd) max_dd = dd;
    }

    return max_dd;
}

const MaxDDTool = () => {
    const [c, setC]   = useState(1000000);
    const [wr, setWr] = useState(45);
    const [aw, setAw] = useState(15);
    const [al, setAl] = useState(10);
    const [ls, setLs] = useState(65);
    const [l, setL]   = useState(4);

    const [mdd, setMdd] = useState(() => runSimulation(1000000, 45, 15, 10, 65, 4));

    useEffect(() => {
        setMdd(runSimulation(c, wr, aw, al, ls, l));
    }, [c, wr, aw, al, ls, l]);

    const maxDdPct   = mdd * 100;
    // Original HTML: mdd * 100 * 0.35
    const avgDdPct   = maxDdPct * 0.35;
    // Original HTML: Math.ceil((max_dd * 100) / 2) months
    const recoveryMo = Math.ceil(maxDdPct / 2);

    return (
        <div className="tct-tool-container">
            <div className="tct-panel-title">📉 5. Max Drawdown Simulator</div>

            <div className="tct-input-wrap d-flex flex-wrap gap-2">
                <InputGroup label="Capital"      value={c}  onChange={setC}  />
                <InputGroup label="Win Rate %"   value={wr} onChange={setWr} />
                <InputGroup label="Avg Win Pts"  value={aw} onChange={setAw} />
                <InputGroup label="Avg Loss Pts" value={al} onChange={setAl} />
                <InputGroup label="Lot Size"     value={ls} onChange={setLs} />
                <InputGroup label="Lots"         value={l}  onChange={setL}  />
            </div>

            <div className="tct-results-grid mt-4">
                <div className="tct-card tct-cyan">
                    <div className="tct-data-row">
                        <span className="tct-label">Simulated Max DD</span>
                        <span className="tct-value big-value val-red">{maxDdPct.toFixed(2)}%</span>
                    </div>
                    <div className="tct-data-row">
                        <span className="tct-label">Average DD</span>
                        <span className="tct-value val-amber">{avgDdPct.toFixed(2)}%</span>
                    </div>
                    <div className="tct-data-row" style={{ borderBottom: 'none' }}>
                        <span className="tct-label">Est. Recovery Time</span>
                        <span className="tct-value val-blue">~{recoveryMo} months</span>
                    </div>
                </div>
            </div>

            <InfoBox
                title="Maximum Drawdown in Trading: The Pain Every Trader Must Understand"
                meta="Maximum drawdown measures the largest drop in trading capital. Learn how to simulate drawdowns and evaluate strategy risk."
                sections={[
                    { title: 'Introduction', content: 'Every trading strategy experiences losing periods.<br><br>Maximum drawdown measures the worst equity drop from peak capital.' },
                    { title: 'Example',      content: 'Capital progression:<br>10L → 12L → 11L → 14L → 9L<br><br>Peak capital = 14L<br>Lowest value = 9L<br>Drawdown = 35%' },
                    { title: 'Why It Matters', content: 'Even profitable strategies can fail if drawdowns are too large.<br>Professional traders carefully manage drawdowns.' },
                ]}
            />
        </div>
    );
};

export default MaxDDTool;